import compact from 'lodash/compact';
export function toFormattedAddress(address, options) {
  if (options === void 0) {
    options = {};
  }
  const {
    hidePostalCode
  } = options;
  const {
    addressLine,
    city,
    countryFullname,
    subdivision,
    postalCode,
    streetAddress
  } = address;
  const addressLineSection = streetAddress != null && streetAddress.name ? compact([streetAddress.name, streetAddress == null ? void 0 : streetAddress.number]).join(' ') : addressLine;
  const subdivisionSection = compact([subdivision, hidePostalCode ? undefined : postalCode]).join(' ');
  const formattedAddress = compact([addressLineSection, city, subdivisionSection, countryFullname]).join(', ');
  return formattedAddress ? formattedAddress : undefined;
}
//# sourceMappingURL=index.js.map